// router.ts

import { createRouter } from "@tanstack/react-router";

import NotFound from "./components/dashboard/not-found";
import { routeTree } from "./routeTree.gen";

export const router = createRouter({
	routeTree,
	defaultPreload: "intent",
	defaultPendingComponent: () => (
		<div className="flex flex-col items-center justify-center gap-4 h-screen w-screen overflow-hidden">
			<div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary" />
		</div>
	),
	// defaultErrorComponent: data => <ErrorComponent data={data} />,
	defaultNotFoundComponent: NotFound
});
// const error = {
// 	error: {
// 		message: "Request failed with status code 400",
// 		name: "AxiosError",
// 		stack: "AxiosError: Request failed with status code 400\n    at settle (http://localhost:3000/node_modules/.vite/deps/axios.js?v=a2f62789:1235:12)\n    at XMLHttpRequest.onloadend (http://localhost:3000/node_modules/.vite/deps/axios.js?v=a2f62789:1566:7)\n    at Axios.request (http://localhost:3000/node_modules/.vite/deps/axios.js?v=a2f62789:2124:41)\n    at async refreshToken (http://localhost:3000/src/routes/vendor.tsx?tsr-split:45:22)\n    at async Module.loader (http://localhost:3000/src/routes/vendor.tsx?tsr-split:222:11)\n    at async runLoader (http://localhost:3000/node_modules/.vite/deps/chunk-NEXSFYDJ.js?v=a2f62789:2925:48)\n    at async http://localhost:3000/node_modules/.vite/deps/chunk-NEXSFYDJ.js?v=a2f62789:3004:25\n    at async Promise.all (index 1)\n    at async http://localhost:3000/node_modules/.vite/deps/chunk-NEXSFYDJ.js?v=a2f62789:3024:15",
// 		config: {
// 			transitional: {
// 				silentJSONParsing: true,
// 				forcedJSONParsing: true,
// 				clarifyTimeoutError: false
// 			},
// 			adapter: [
// 				"xhr",
// 				"http",
// 				"fetch"
// 			],
// 			transformRequest: [
// 				null
// 			],
// 			transformResponse: [
// 				null
// 			],
// 			timeout: 0,
// 			xsrfCookieName: "XSRF-TOKEN",
// 			xsrfHeaderName: "X-XSRF-TOKEN",
// 			maxContentLength: -1,
// 			maxBodyLength: -1,
// 			env: {},
// 			headers: {
// 				"Accept": "application/json, text/plain, */*",
// 				"Content-Type": "application/json"
// 			},
// 			baseURL: "https://api.dev.intasida.com/v1",
// 			method: "post",
// 			url: "auth/refresh_token",
// 			data: "{\"userId\":\"5dc4bad9-d709-4082-be10-39c2103d2f14\",\"oldRefreshToken\":\"eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiI1ZGM0YmFkOS1kNzA5LTQwODItYmUxMC0zOWMyMTAzZDJmMTQiLCJyb2xlcyI6IkJVWUVSLFZFTkRPUiIsInBlcm1pc3Npb25zIjpudWxsLCJpYXQiOjE3NTAxNTIwMTgsImV4cCI6MTc1MDU4NDAxOH0.hzlTnz6hro40hVpS_qSVKSG5zNydIyRj8QxNrkfwaj8\"}"
// 		},
// 		code: "ERR_BAD_REQUEST",
// 		status: 400
// 	}
// };

// function ErrorComponent({ data }: { data: ErrorComponentProps }) {
// 	const [canRetry, setCanRetry] = useState(false);
// 	const [countdown, setCountdown] = useState(60);

// 	const logout = useAuthStore(state => state.logout);

// 	if (data.error.status === 401 || data.error.status === 403 || data.error.status === 400) {
// 		logout();
// 	}

// 	useEffect(() => {
// 		const timer = setInterval(() => {
// 			setCountdown((prev) => {
// 				if (prev <= 1) {
// 					clearInterval(timer);
// 					setCanRetry(true);
// 					return 0;
// 				}
// 				return prev - 1;
// 			});
// 		}, 1000);

// 		return () => clearInterval(timer);
// 	}, []);

// 	return (
// 		<div className="flex flex-col items-center justify-center gap-6 h-screen w-screen overflow-hidden bg-gray-50">
// 			<div className="flex flex-col items-center gap-2">
// 				<div className="text-4xl font-bold text-gray-900">Oops!</div>
// 				<div className="text-lg text-gray-600">Something went wrong</div>
// 			</div>
// 			<div className="text-sm text-gray-500 max-w-md text-center px-4">
// 				We apologize for the inconvenience. Please try again or contact support if the problem persists.
// 			</div>
// 			<Button
// 				onClick={() => router.invalidate()}
// 				className="mt-4"
// 				variant="default"
// 				disabled={!canRetry}
// 			>
// 				{canRetry ? "Try Again" : `Please wait ${countdown}s`}
// 			</Button>
// 		</div>
// 	);
// }
